import { FormikTextField } from '@components/Inputs';
import DeleteIcon from '@mui/icons-material/Delete';
import {
	Box,
	Button,
	Divider,
	Grid,
	IconButton,
	Typography
} from '@mui/material';
import { FieldArray } from 'formik';
import React from 'react';
import { IFlowConditions, ITaskConditions } from 'types/flows';
import { FORM_KEYS, newCondition } from './helpers';
import TaskConditionItem from './TaskConditionItem';
import { ConditionChangeCallback } from './types';

interface ITaskConditionsListProps {
	conditions: IFlowConditions;
	taskConditions: ITaskConditions;
	onConditionChange?: ConditionChangeCallback;
}

const TaskConditionsList = ({
	conditions,
	taskConditions,
	onConditionChange
}: ITaskConditionsListProps) => (
	<FieldArray
		name={FORM_KEYS.taskConditions}
		render={(arrayHelpers) => (
			<Box pt={2}>
				<Grid container>
					{taskConditions.map((c, i) => (
						/* eslint react/no-array-index-key: 0 */
						<React.Fragment key={`${i}`}>
							<Grid item xs={1} pt={1} alignItems="center">
								<Typography variant="body1" whiteSpace="break-spaces">
									{intl.tr(
										`add.condition.task.dialog.conditions.${
											i === 0 ? 'if' : 'elseif'
										}`
									)}
								</Typography>
							</Grid>
							<Grid item xs={10} data-testid="task-condition">
								<TaskConditionItem
									conditions={conditions}
									taskCondition={c}
									formikName={`${FORM_KEYS.taskConditions}.${i}`}
									onConditionChange={onConditionChange}
								/>
								{taskConditions.length > 1 && (
									<Box pt={4} pb={taskConditions.length - 1 === i ? 0 : 4}>
										<Divider />
									</Box>
								)}
							</Grid>
							<Grid item xs={1} pt={0}>
								{taskConditions.length > 1 && (
									<IconButton
										onClick={() => arrayHelpers.remove(i)}
										aria-label={intl.tr('button.delete')}
										data-testid="delete-condition-input"
									>
										<DeleteIcon color="primary" />
									</IconButton>
								)}
							</Grid>
						</React.Fragment>
					))}
				</Grid>
				<Box px={4} py={3}>
					<Button
						color="primary"
						onClick={() => {
							arrayHelpers.push(newCondition());
						}}
					>
						{intl.tr('add.condition.task.dialog.conditions.new.rule')}
					</Button>
				</Box>
				<Box pt={2}>
					<Grid container>
						<Grid item xs={1} pt={1} alignItems="center">
							<Typography variant="body1" whiteSpace="break-spaces">
								{intl.tr('add.condition.task.dialog.conditions.else')}
							</Typography>
						</Grid>
						<Grid item xs={10} pb={2} ml={0}>
							<FormikTextField
								name="elseName"
								size="small"
								fullWidth
								data-testid="task-else-condition"
								label={intl.tr(
									'add.condition.task.dialog.conditions.condition.name'
								)}
							/>
						</Grid>
					</Grid>
				</Box>
			</Box>
		)}
	/>
);

TaskConditionsList.defaultProps = {
	onConditionChange: () => {}
};

export default TaskConditionsList;
